import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Entry } from 'contentful';
import { BehaviorSubject } from 'rxjs';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { PageId } from 'src/app/shared/utilities/pageids.enum';

@Injectable({
  providedIn: 'root',
})
export class CoreApisService {
  private coreApiHeroSubject$ = new BehaviorSubject<any>(null);
  public coreApiHero$ = this.coreApiHeroSubject$.asObservable();

  private bankingSubject$ = new BehaviorSubject<any>(null);
  public banking$ = this.bankingSubject$.asObservable();

  private fxSectionSubject$ = new BehaviorSubject<any>(null);
  public fxSection$ = this.fxSectionSubject$.asObservable();

  private powerfulApiSubject$ = new BehaviorSubject<any>(null);
  public powerfulApi$ = this.powerfulApiSubject$.asObservable();

  private onboardingSubject$ = new BehaviorSubject<any>(null);
  public onboarding$ = this.onboardingSubject$.asObservable();

  private ventureSubject$ = new BehaviorSubject<any>(null);
  public venture$ = this.ventureSubject$.asObservable();

  private faqSubject$ = new BehaviorSubject<any>(null);
  public faq$ = this.faqSubject$.asObservable();

  private insightsSubject$ = new BehaviorSubject<any>(null);
  public insights$ = this.insightsSubject$.asObservable();

  private companiesSubject$ = new BehaviorSubject<any>(null);
  public companies$ = this.companiesSubject$.asObservable();

  private blogPanelSubject$ = new BehaviorSubject<any>(null);
  public blogPanel$ = this.blogPanelSubject$.asObservable();

  private vertoApiSubject$ = new BehaviorSubject<any>(null);
  public vertoApi$ = this.vertoApiSubject$.asObservable();

  private productsSubject$ = new BehaviorSubject<any>(null);
  public products$ = this.productsSubject$.asObservable();

  private apiSubject$ = new BehaviorSubject<any>(null);
  public api$ = this.apiSubject$.asObservable();

  constructor(
    private contentful: ContentfulService,
    private meta: MetaService,
    private http: HttpClient,
    private route: ActivatedRoute
  ) {}

  coreApiPageData: any;

  getCoreApiPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.coreApiPageData = mod.filter(
          x => x?.fields['id'] == PageId.coreApiPage
        );

        const coreApiHeroData =
          this.coreApiPageData[0].fields.psHeroPanel.fields;
        if (coreApiHeroData) {
          this.coreApiHeroSubject$.next(coreApiHeroData);
        }

        const bankingData =
          this.coreApiPageData[0].fields.psProductSuite.fields;
        if (bankingData) {
          this.bankingSubject$.next(bankingData);
        }

        const optimizeFx =
          this.coreApiPageData[0].fields.psValuePropPanel.fields;
        if (optimizeFx) {
          this.fxSectionSubject$.next(optimizeFx);
        }

        const powerfulApi =
          this.coreApiPageData[0].fields.psValuePropPanel2.fields;
        if (powerfulApi) {
          this.powerfulApiSubject$.next(powerfulApi);
        }

        const onboardingApi =
          this.coreApiPageData[0].fields.psMobileAppGetStartedPanel.fields;

        if (onboardingApi) {
          this.onboardingSubject$.next(onboardingApi);
        }

        const venture = this.coreApiPageData[0].fields.psCustomerStories.fields;

        if (venture) {
          this.ventureSubject$.next(venture);
        }

        const faqs = this.coreApiPageData[0].fields.psFaqPanel.fields;
        if (faqs) {
          this.faqSubject$.next(faqs);
        }

        const companies =
          this.coreApiPageData[0].fields.psCustomerStatsContentPanel.fields;
        if (companies) {
          this.companiesSubject$.next(companies);
        }

        const vertoApi =
          this.coreApiPageData[0].fields.psGetStartedPanel.fields;
        if (vertoApi) {
          this.vertoApiSubject$.next(vertoApi);
        }
        //  const blogPanel = this.coreApiPageData[0].fields.

        const latestNewsBlogPanelData =
          this.coreApiPageData[0].fields.psBlogPanel[0].fields;
        if (latestNewsBlogPanelData) {
          this.blogPanelSubject$.next(latestNewsBlogPanelData);
        }

        const productsPanel =
          this.coreApiPageData[0].fields.psOtherProductsPanel.fields;
        if (productsPanel) {
          this.productsSubject$.next(productsPanel);
        }

        const apiPanel = this.coreApiPageData[0].fields.psProductSuite2.fields;
        if (apiPanel) {
          this.apiSubject$.next(apiPanel);
        }
      });
  }
}
